import CarousellDots from './CarousellDots'

export default CarousellDots
